function Experience(){
    return(
        <div className="experience">
            <h1>Work Experience</h1>
            
            <h3>IT Programmer (IHBS)<span>2018 - Now</span></h3>
            <p>Develop and creating software programs, integrating systems and software, training end-users, modifying source-code, and maintaining the current systems</p>
            
            <h3>IT Programmer (PT. Klip Plastik Indonesia)<span>2017 - 2018</span></h3>
            <p>Develop and creating software programs, integrating systems and software, training end-users, modifying source-code, and maintaining the current systems</p>
            
            <h3>Drafter Engineering (PT. Surya Sealindo Teknologi) <span>2015 - 2016</span></h3>
            <p>Design and prepare shopdrawing using computer aided design and drafting (CADD) software</p>
        </div>
    );
}

export default Experience;